import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";

const ease = [0.22, 1, 0.36, 1];

export default function Creds() {
  const { t } = useLang();
  return (
    <section className="creds section-line" data-testid="creds-section">
      {t.creds.map((c, i) => (
        <motion.div
          className="cred"
          key={i}
          data-testid={`cred-${i}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.1, ease }}
        >
          <div className="num">{c.num}</div>
          <div className="lbl">{c.lbl}</div>
        </motion.div>
      ))}
    </section>
  );
}
